import { render, staticRenderFns } from "./verify-identity-with-otp.vue?vue&type=template&id=93d1b1ce&scoped=true&"
import script from "./verify-identity-with-otp.vue?vue&type=script&lang=js&"
export * from "./verify-identity-with-otp.vue?vue&type=script&lang=js&"
import style0 from "./verify-identity-with-otp.vue?vue&type=style&index=0&id=93d1b1ce&lang=scss&scoped=true&"
import style1 from "@/assets/auth-screen.scss?vue&type=style&index=1&id=93d1b1ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d1b1ce",
  null
  
)

component.options.__file = "verify-identity-with-otp.vue"
export default component.exports